import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ErrorPanelProps {
  error: string | null;
  className?: string;
  showBackToHome?: boolean;
}

const ErrorPanel: React.FC<ErrorPanelProps> = ({ error, className = '', showBackToHome = false }) => {
  const navigate = useNavigate();

  if (!error) return null;

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className={`bg-red-600/90 text-white px-6 py-3 rounded-3xl text-center text-sm font-medium w-full max-w-xs ${className}`}>
      <div className="mb-3">{error}</div>
      {showBackToHome && (
        <button 
          onClick={handleBackToHome}
          className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded-2xl text-xs font-bold transition-colors"
        >
          Back to Home
        </button>
      )}
    </div>
  );
};

export default ErrorPanel;